import { useState, useRef } from 'react';

export function usePanelLayout() {
    const [leftPanelSizes, setLeftPanelSizes] = useState([70, 30]);
    const [rightPanelSizes, setRightPanelSizes] = useState([70, 30]);

    const leftAllotmentRef = useRef<any>(null);
    const rightAllotmentRef = useRef<any>(null);

    return {
        leftPanelSizes,
        setLeftPanelSizes,
        rightPanelSizes,
        setRightPanelSizes,
        leftAllotmentRef,
        rightAllotmentRef,
    };
}
